import { useState } from 'react'
import { Box, IconButton } from '@mui/material'
import { Checkmark20Regular, Copy20Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import { copyIcon14Sx } from '../shared/copyIconSx.js'

/**
 * @param {{ text: string, label?: string }} props
 */
export default function TraceCopyButton({ text, label = 'Copy' }) {
  const [copied, setCopied] = useState(false)

  return (
    <Tooltip text={copied ? 'Copied!' : label} placement="top">
      <IconButton
        size="small"
        aria-label={label}
        onClick={(e) => {
          e.stopPropagation()
          navigator.clipboard.writeText(text)
          setCopied(true)
          setTimeout(() => setCopied(false), 2000)
        }}
        sx={{ width: 24, height: 24, flexShrink: 0 }}
      >
        {copied ? (
          <Box component="span" sx={copyIcon14Sx} aria-hidden>
            <Checkmark20Regular />
          </Box>
        ) : (
          <Box component="span" sx={copyIcon14Sx} aria-hidden>
            <Copy20Regular />
          </Box>
        )}
      </IconButton>
    </Tooltip>
  )
}
